const middleware = {}

middleware['auth'] = require('../../../middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['new-archive'] = require('../../../middleware/new-archive.js')
middleware['new-archive'] = middleware['new-archive'].default || middleware['new-archive']

middleware['partner'] = require('../../../middleware/partner.js')
middleware['partner'] = middleware['partner'].default || middleware['partner']

middleware['require-builder-access'] = require('../../../middleware/require-builder-access.js')
middleware['require-builder-access'] = middleware['require-builder-access'].default || middleware['require-builder-access']

middleware['return'] = require('../../../middleware/return.js')
middleware['return'] = middleware['return'].default || middleware['return']

export default middleware
